"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getEntityElement_1 = require("./getEntityElement");
var tryTriggerEntityEvent_1 = require("./tryTriggerEntityEvent");
var roosterjs_editor_core_1 = require("roosterjs-editor-core");
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
/**
 * @internal
 * A content edit feature to trigger EntityOperation event with operation "Click" when user
 * clicks on a readonly entity.
 */
exports.ClickOnEntityFeature = {
    keys: [13 /* ENTER */],
    shouldHandleEvent: cacheGetReadonlyEntityElement,
    handleEvent: function (event, editor) {
        var entityElement = cacheGetReadonlyEntityElement(event, editor);
        tryTriggerEntityEvent_1.default(editor, entityElement, 1 /* Click */, event.rawEvent);
    },
};
/**
 * @internal
 * A content edit feature to trigger EntityOperation event with operation "Escape" when user
 * presses ESC on a readonly entity.
 */
exports.EscapeFromEntityFeature = {
    keys: [27 /* ESCAPE */],
    shouldHandleEvent: cacheGetReadonlyEntityElement,
    handleEvent: function (event, editor) {
        var entityElement = cacheGetReadonlyEntityElement(event, editor);
        tryTriggerEntityEvent_1.default(editor, entityElement, 3 /* Escape */, event.rawEvent);
    },
};
/**
 * @internal
 * A content edit feature to split current line into two lines at the cursor when user presses
 * ENTER right before a readonly entity.
 * Browser's default behavior will insert an extra BR tag before the entity which causes an extra
 * empty line. So we override the default behavior here.
 */
exports.EnterBeforeReadonlyEntityFeature = {
    keys: [13 /* ENTER */],
    shouldHandleEvent: function (event, editor) {
        return cacheGetNeighborEntityElement(event, editor, true /*isNext*/, false /*collapseOnly*/, true /*checkForSameLine*/);
    },
    handleEvent: function (event, editor) {
        var _a;
        event.rawEvent.preventDefault();
        var range = editor.getSelectionRange();
        var node = roosterjs_editor_dom_1.Position.getEnd(range).normalize().node;
        var br = editor.getDocument().createElement('BR');
        node.parentNode.insertBefore(br, node.nextSibling);
        var block = editor.getBlockElementAtNode(node);
        var newContainer;
        if (block) {
            newContainer = block.collapseToSingleElement();
            (_a = br.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(br);
        }
        editor.getSelectionRange().deleteContents();
        if (newContainer.nextSibling) {
            editor.select(newContainer.nextSibling, 0 /* Begin */);
        }
    },
};
/**
 * @internal
 * A content edit feature to trigger EntityOperation event with operation "RemoveFromEnd" when user
 * press BACKSPACE right after an entity
 */
exports.BackspaceAfterEntityFeature = {
    keys: [8 /* BACKSPACE */],
    shouldHandleEvent: function (event, editor) {
        return cacheGetNeighborEntityElement(event, editor, false /*isNext*/, true /*collapseOnly*/);
    },
    handleEvent: function (event, editor) {
        var element = cacheGetNeighborEntityElement(event, editor, false /*isNext*/, true /*collapseOnly*/);
        tryTriggerEntityEvent_1.default(editor, element, 5 /* RemoveFromEnd */, event.rawEvent);
    },
};
/**
 * @internal
 * A content edit feature to trigger EntityOperation event with operation "RemoveFromStart" when user
 * press DELETE right after an entity
 */
exports.DeleteBeforeEntityFeature = {
    keys: [46 /* DELETE */],
    shouldHandleEvent: function (event, editor) {
        return cacheGetNeighborEntityElement(event, editor, true /*isNext*/, true /*collapseOnly*/);
    },
    handleEvent: function (event, editor) {
        var element = cacheGetNeighborEntityElement(event, editor, true /*isNext*/, true /*collapseOnly*/);
        tryTriggerEntityEvent_1.default(editor, element, 4 /* RemoveFromStart */, event.rawEvent);
    },
};
function cacheGetReadonlyEntityElement(event, editor) {
    return roosterjs_editor_core_1.cacheGetEventData(event, 'READONLY_ENTITY_ELEMENT', function () {
        var entityElement = getEntityElement_1.default(editor, event.rawEvent.target);
        return entityElement && !entityElement.isContentEditable ? entityElement : null;
    });
}
function cacheGetNeighborEntityElement(event, editor, isNext, collapseOnly, checkForSameLine) {
    return roosterjs_editor_core_1.cacheGetEventData(event, 'NEIGHBOR_ENTITY_ELEMENT_' + isNext + '_' + collapseOnly + '_' + !!checkForSameLine, function () {
        var range = editor.getSelectionRange();
        if (collapseOnly && !range.collapsed) {
            return null;
        }
        var pos = roosterjs_editor_dom_1.Position.getEnd(range);
        var lookForPrev = !isNext && (pos.node.nodeType != 3 /* Text */ || pos.offset == 0);
        var lookForNext = isNext && (pos.node.nodeType != 3 /* Text */ || pos.isAtEnd);
        var entityNode = null;
        if (lookForNext || lookForPrev) {
            var traverser = editor.getBodyTraverser(pos.node);
            var sibling = lookForPrev
                ? traverser.getPreviousInlineElement()
                : traverser.getNextInlineElement();
            var node = sibling && sibling.getContainerNode();
            if (checkForSameLine) {
                var block = editor.getBlockElementAtNode(pos.node);
                if (!block || !block.contains(node)) {
                    node = null;
                }
            }
            entityNode = getEntityElement_1.default(editor, node);
        }
        return entityNode;
    });
}
//# sourceMappingURL=EntityFeatures.js.map